import React from "react";
import Button from "@material-ui/core/Button";
import { FormSection, change } from "redux-form";
import {
  FlexGridItem,
  FlexTextField,
  TextArea,
  SimpleCondField,
  maxLength200,
} from "./form_utility";
import {
  Grid,
  ExpansionPanel,
  // ExpansionPanelSummary,
  Tooltip,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Add from "@material-ui/icons/Add";

import Delete from "@material-ui/icons/Delete";
import Undo from "@material-ui/icons/Undo";
// import { PRIMARY_COLOR } from "src/constants/color";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import { MAX_LENGTH_20, FORM_ERROR_MESSAGE } from "../../constants/data.js";
import { Toaster } from "../common/toaster.component";
import { FieldError } from "../../styles/general";
import { StyledExpansionPanelSummary } from "../../styles/form";

class POForm extends React.Component<any, any> {
  public state: any = {
    poFormData: [],
    toaster: {
      message: "",
      success: false,
      visible: false,
    },
  };

  public componentDidMount() {
    const { poFormData, toaster } = this.state;
    const { mainForm, isToasterVisible } = this.props;

    if (
      mainForm.mainForm &&
      mainForm.mainForm.values &&
      mainForm.mainForm.values.pos &&
      mainForm.mainForm.values.pos.length
    ) {
      mainForm.mainForm.values.pos.map((value: any, index: any) => {
        const isDeleted = value.deleted ? true : false;
        const tempPoObj = {
          deleted: isDeleted,
          poNoError: this.validationPoNoPoItemNo(value.poNo, isDeleted),
          poItemNoError: this.validationPoNoPoItemNo(value.poItemNo, isDeleted),
        };
        if (
          !isToasterVisible &&
          !toaster.visible &&
          // @ts-ignore
          (tempPoObj.poNoError.isError || tempPoObj.poItemNoError.isError)
        ) {
          toaster.visible = true;
          toaster.message = FORM_ERROR_MESSAGE;
          this.setState({
            toaster,
          });
        }
        poFormData.push(tempPoObj);
      });
      this.setState({ poFormData });
    }
  }

  public render() {
    const { fields, disableForm, dispatch } = this.props;
    const { poFormData, toaster } = this.state;
    return (
      <React.Fragment>
        <Toaster
          message={toaster.message}
          open={toaster.visible}
          close={this.closeToaster}
          success={toaster.success}
        />
        <h4>PO Details:</h4>
        {fields.map((member: any, index: any) => {
          let enableValidation: any = null;
          const poNo = fields.get(index).poNo ? fields.get(index).poNo : "";
          const poItemNo = fields.get(index).poItemNo
            ? fields.get(index).poItemNo
            : "";
          const poTitle: string =
            `PO ${index + 1}` +
            (poNo ? " - " + poNo : "") +
            (poItemNo ? " - " + poItemNo : "");
          const hasPoData = poFormData.length ? true : false;

          if (
            hasPoData &&
            poFormData[index].hasOwnProperty("deleted") &&
            poFormData[index].deleted === true
          ) {
            enableValidation = false;
          } else {
            enableValidation = true;
          }
          return (
            <FormSection key={index} name={member}>
              <FlexGridItem style={{ paddingBottom: 0, paddingTop: 0 }} xs={12}>
                <ExpansionPanel
                  style={{ flex: 1, margin: "5px" }}
                  defaultExpanded={disableForm}
                  disabled={disableForm}
                >
                  <StyledExpansionPanelSummary
                    // style={{
                    //   backgroundColor: `${PRIMARY_COLOR}`,
                    //   display: "flex",
                    //   alignItems: "center",
                    // }}
                    isPoNoError={
                      hasPoData && poFormData[index].poNoError.isError
                    }
                    isPoItemNoError={
                      hasPoData && poFormData[index].poItemNoError.isError
                    }
                    expandIcon={<ExpandMoreIcon />}
                  >
                    {!enableValidation ? (
                      <Tooltip title="Undo delete">
                        <IconButton
                          onClick={this.undoDeletedPo.bind(
                            this,
                            dispatch,
                            member,
                            index
                          )}
                          style={{ color: "#000000" }}
                        >
                          <Undo />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    <Tooltip title="Mark for deletion">
                      <IconButton
                        onClick={this.deletePO.bind(
                          this,
                          dispatch,
                          member,
                          index
                        )}
                        style={{ color: "#000000" }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                    <div
                      style={{
                        paddingLeft: "16px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div>{poTitle}</div>
                      <SimpleCondField
                        name="deleted"
                        condition={(val: any) => val}
                      >
                        <div style={{ marginLeft: "16px" }} color="error">
                          (Marked for deletion)
                        </div>
                      </SimpleCondField>
                    </div>
                  </StyledExpansionPanelSummary>
                  <Grid container={true} style={{ flex: 1, padding: "24px" }}>
                    <FlexGridItem xs={6}>
                      <TextField
                        type="number"
                        name="poNo"
                        label="PoNo"
                        disabled={disableForm}
                        onChange={this.handlePoNoChange.bind(
                          this,
                          member,
                          index
                        )}
                        value={poNo}
                        fullWidth={true}
                        error={hasPoData && poFormData[index].poNoError.isError}
                        required={enableValidation}
                        InputLabelProps={{ style: { paddingLeft: "5px" } }}
                        style={{
                          flex: 1,
                          paddingLeft: "5px",
                          paddingRight: "5px",
                        }}
                      />
                      {hasPoData &&
                        poFormData[index].poNoError.errorMessage && (
                          <FieldError>
                            {poFormData[index].poNoError.errorMessage}
                          </FieldError>
                        )}
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <TextField
                        type="number"
                        name="poItemNo"
                        label="PO Item No"
                        disabled={disableForm}
                        onChange={this.handlePoItemNoChange.bind(
                          this,
                          member,
                          index
                        )}
                        value={poItemNo}
                        fullWidth={true}
                        error={
                          hasPoData && poFormData[index].poItemNoError.isError
                        }
                        required={enableValidation}
                        InputLabelProps={{ style: { paddingLeft: "5px" } }}
                        style={{
                          flex: 1,
                          paddingLeft: "5px",
                          paddingRight: "5px",
                        }}
                      />
                      {hasPoData &&
                        poFormData[index].poItemNoError.errorMessage && (
                          <FieldError>
                            {poFormData[index].poItemNoError.errorMessage}
                          </FieldError>
                        )}
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="deliveryNo"
                        label="Delivery No"
                        disabled={disableForm}
                        validate={[maxLength200]}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="shipmentNo"
                        label="Shipment No"
                        disabled={disableForm}
                        validate={[maxLength200]}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="materialShortText"
                        label="Material short text"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="materialGroup"
                        label="Material group"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="material"
                        label="Material"
                        disabled={disableForm}
                        validate={[maxLength200]}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="assetNumbers"
                        label="Asset numbers"
                        disabled={disableForm}
                        validate={[maxLength200]}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={12}>
                      <TextArea
                        name="batchNo"
                        label="Batch Information"
                        style={{ marginTop: "15px", width: "100%" }}
                        disabled={disableForm}
                      />
                      {/* <FlexTextField name="packSize" label="Pack size" /> */}
                    </FlexGridItem>
                    {/* <FlexGridItem xs={6}>
                        <DateField
                          name="expiryDate"
                          label="Expiry date"
                          format={timestampToDate}
                          normalize={dateToTimestamp}
                          validate={validDate}
                        />
                      </FlexGridItem>
                      <FlexGridItem xs={6}>
                        <FlexTextField name="serialNo" label="Serial No" />
                      </FlexGridItem> */}
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="vendorNo"
                        label="Vendor No"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="vendorName"
                        label="Vendor name"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="freightForwarderNo"
                        label="Freight Forwarder No"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="freightForwarderName"
                        label="Freight Forwarder name"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="orderType"
                        label="Order Type"
                        disabled={true}
                      />
                    </FlexGridItem>
                    <FlexGridItem xs={6}>
                      <FlexTextField
                        name="soldToParty"
                        label="Sold to party"
                        disabled={true}
                      />
                    </FlexGridItem>
                  </Grid>
                </ExpansionPanel>
              </FlexGridItem>
            </FormSection>
          );
        })}
        <div style={{ padding: "10px 5px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.addEmptyPO}
            disabled={disableForm}
          >
            Add
            <Add />
          </Button>
        </div>
      </React.Fragment>
    );
  }

  closeToaster = () => {
    this.setState({
      toaster: {
        message: "",
        success: false,
        visible: false,
      },
    });
  };

  addEmptyPO = () => {
    const { fields, isToasterVisible } = this.props;
    let { poFormData, toaster } = this.state;
    const poObj = {
      deleted: false,
      poNoError: {
        isError: true,
        errorMessage: `Value is required for this field`,
      },
      poItemNoError: {
        isError: true,
        errorMessage: `Value is required for this field`,
      },
    };
    const fieldsLength = fields.length;
    const poDataLength = poFormData.length;
    if (fieldsLength === poDataLength) {
      poFormData.push(poObj);
    } else {
      for (let index = 0; index < fieldsLength; index++) {
        poFormData[index] = {
          deleted: false,
          poNoError: {},
          poItemNoError: {},
        };
      }
      poFormData.push(poObj);
    }
    fields.push(poObj);
    if (!isToasterVisible) {
      toaster.visible = true;
      toaster.message = FORM_ERROR_MESSAGE;
      toaster.success = false;
    }

    this.setState({
      poFormData,
      toaster,
    });
  };

  deletePO = (dispatch: any, member: any, index: any, event: any) => {
    let { poFormData } = this.state;
    const { fields } = this.props;

    const fieldsLength = fields.length;
    const poDataLength = poFormData.length;
    event.preventDefault();
    event.stopPropagation();

    if (fieldsLength === poDataLength) {
      poFormData[index].deleted = true;
    } else {
      for (let forIndex = 0; forIndex < fieldsLength; forIndex++) {
        poFormData[forIndex] = {
          deleted: false,
          poNoError: {},
          poItemNoError: {},
        };
      }
      poFormData[index].deleted = true;
    }
    const poNo = fields.get(index).poNo ? fields.get(index).poNo : "";
    const poItemNo = fields.get(index).poItemNo
      ? fields.get(index).poItemNo
      : "";

    poFormData[index].poNoError = this.validationPoNoPoItemNo(
      poNo,
      poFormData[index].deleted
    );
    poFormData[index].poItemNoError = this.validationPoNoPoItemNo(
      poItemNo,
      poFormData[index].deleted
    );

    this.setState({
      poFormData,
    });
    dispatch(change("mainForm", `${member}.deleted`, true));
  };

  undoDeletedPo = (dispatch: any, member: any, index: any, event: any) => {
    let { poFormData } = this.state;
    const { fields } = this.props;
    event.preventDefault();
    event.stopPropagation();

    poFormData[index].deleted = false;
    const poNo = fields.get(index).poNo ? fields.get(index).poNo : "";
    const poItemNo = fields.get(index).poItemNo
      ? fields.get(index).poItemNo
      : "";

    poFormData[index].poNoError = this.validationPoNoPoItemNo(
      poNo,
      poFormData[index].deleted
    );
    poFormData[index].poItemNoError = this.validationPoNoPoItemNo(
      poItemNo,
      poFormData[index].deleted
    );

    this.setState({
      poFormData,
    });
    dispatch(change("mainForm", `${member}.deleted`, false));
  };

  handlePoNoChange = (name: any, index: any, event: any) => {
    const { dispatch, fields, isToasterVisible } = this.props;
    const { poFormData, toaster } = this.state;

    const value = event.target.value;
    const fieldsLength = fields.length;
    const poDataLength = poFormData.length;

    if (fieldsLength !== poDataLength) {
      for (let forIndex = 0; forIndex < fieldsLength; forIndex++) {
        poFormData[forIndex] = {
          deleted: false,
          poNoError: {},
          poItemNoError: {},
        };
      }
    }
    poFormData[index].poNoError = this.validationPoNoPoItemNo(
      value,
      poFormData[index].deleted
    );

    // Check Error
    if (
      !isToasterVisible &&
      !toaster.visible &&
      (poFormData[index].poNoError.isError ||
        poFormData[index].poItemNoError.isError)
    ) {
      toaster.visible = true;
      toaster.message = FORM_ERROR_MESSAGE;
      toaster.success = false;
    } else if (
      toaster.visible &&
      !poFormData[index].poNoError.isError &&
      !poFormData[index].poItemNoError.isError
    ) {
      toaster.visible = false;
      toaster.message = "";
      toaster.success = false;
    }
    dispatch(change("mainForm", `${name}.poNo`, value));
    this.setState({ poFormData, toaster });
  };

  handlePoItemNoChange = (name: any, index: any, event: any) => {
    const { dispatch, fields, isToasterVisible } = this.props;
    const { poFormData, toaster } = this.state;

    const value = event.target.value;
    const fieldsLength = fields.length;
    const poDataLength = poFormData.length;

    if (fieldsLength !== poDataLength) {
      for (let forIndex = 0; forIndex < fieldsLength; forIndex++) {
        poFormData[forIndex] = {
          deleted: false,
          poNoError: {},
          poItemNoError: {},
        };
      }
    }

    poFormData[index].poItemNoError = this.validationPoNoPoItemNo(
      value,
      poFormData[index].deleted
    );
    dispatch(change("mainForm", `${name}.poItemNo`, value));

    // Check Error
    if (
      !isToasterVisible &&
      !toaster.visible &&
      (poFormData[index].poNoError.isError ||
        poFormData[index].poItemNoError.isError)
    ) {
      toaster.visible = true;
      toaster.message = FORM_ERROR_MESSAGE;
      toaster.success = false;
    } else if (
      toaster.visible &&
      !poFormData[index].poNoError.isError &&
      !poFormData[index].poItemNoError.isError
    ) {
      toaster.visible = false;
      toaster.message = "";
      toaster.success = false;
    }

    this.setState({ poFormData, toaster });
  };

  validationPoNoPoItemNo = (value: any, isDeleted: any) => {
    const errorObj = {
      isError: false,
      errorMessage: "",
    };

    // Validations based on deleted value;
    if (isDeleted) {
      if (value && value.length > MAX_LENGTH_20) {
        errorObj.isError = true;
        errorObj.errorMessage = `Value should be ${MAX_LENGTH_20} characters or less`;
      }
    } else {
      if (!value) {
        errorObj.isError = true;
        errorObj.errorMessage = `Value is required for this field`;
      } else if (value && value.length > MAX_LENGTH_20) {
        errorObj.isError = true;
        errorObj.errorMessage = `Value should be ${MAX_LENGTH_20} characters or less`;
      }
    }
    return errorObj;
  };
}

export default POForm;
